<template>
  <div class="introduction-header" @click="showModal">
    <h2>{{title}}</h2>
    <p>{{desc}}</p>
    <div class="introduction-arrow" v-if="type === 'company'"></div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'person'
    },
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    modalTitle: {
      type: String,
      default: ''
    },
    modalDesc: {
      type: String,
      default: ''
    }
  },
  methods: {
    showModal () {
      if (this.type !== 'company') return
      this.$alert({
        type: 'tips',
        content: this.modalTitle,
        desc: this.modalDesc
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "../styles/variable.styl";

.introduction-header {
  position: relative;
  margin-bottom: 20px;
  padding: 60px 100px;
  text-align: center;
  line-height: 1.5;
  background-color: #fff;
  color: $ucar_font_color;

  h2 {
    margin-bottom: 20px;
    text-align: center;
    font-size: $ucar_font_h3;
  }

  p {
    font-size: $ucar_font_normal;
    color: $ucar_price_color;
  }

  .introduction-arrow {
    position: absolute;
    top: 50%;
    right: 60px;
    border-top: 2px solid #999;
    border-right: 2px solid #999;
    height: 20px;
    width: 20px;
    box-sizing: border-box;
    transform: rotate(45deg) translate3d(0, -50%, 0);
  }
}
</style>
